module.exports = __webpack_public_path__ + "img/add.2e6aa32b.svg";